import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '../../button/button.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AddLocalePipe } from '../../../pipes/url-locale.pipe';
import { TranslateRoutePipe } from '../../../pipes/translate-route.pipe';
import { LocaleSwitcherComponent } from '../../footer/footer-bottom/locale-switcher/locale-switcher.component';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'footer[app-megamenu-footer]',
  imports: [
    ButtonComponent,
    SvgIconComponent,
    RouterLink,
    TranslocoModule,
    AddLocalePipe,
    TranslateRoutePipe,
    LocaleSwitcherComponent,
  ],
  templateUrl: './megamenu-footer.component.html',
  styleUrls: ['./megamenu-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenuFooterComponent {
  private readonly auth = inject(AuthenticationService);

  get isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }
}
